var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "w-100 navbar navbar-expand-sm justify-content-end" },
    [
      _c("ul", { staticClass: "navbar-nav" }, [
        _c(
          "li",
          { staticClass: "nav-item" },
          [
            _c(
              "router-link",
              {
                staticClass: "nav-link",
                attrs: { to: "/experience" },
                on: {
                  click: function($event) {
                    return _vm.trackHomeCosaFareNy()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.TOP_LINK_COSA_FARE))]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.TOP_LINK_CAMBIA_ISOLA !== undefined
          ? _c(
              "li",
              { staticClass: "nav-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link",
                    attrs: { to: "/experience" },
                    on: {
                      click: function($event) {
                        return _vm.trackHomeCambiaIsola()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.TOP_LINK_CAMBIA_ISOLA))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: _vm.TOP_LINK_CHI_SIAMO_URL, target: "_blank" },
              on: { click: _vm.trackHomeChiSiamo }
            },
            [_vm._v(_vm._s(_vm.TOP_LINK_CHI_SIAMO))]
          )
        ]),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "nav-item" },
          [
            _c(
              "router-link",
              {
                staticClass: "nav-link badge badge-secondary",
                attrs: { to: "/experience" }
              },
              [_vm._v("Area agenzie di viaggio")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b479a3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b479a3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/default/Navbar.vue
// module id = null
// module chunks = 